module.exports = __webpack_public_path__ + "static/media/selfpic.f6cfc9ee.jpeg";